import {combineReducers} from "redux";
import {inboxReducer} from "./inbox";
import {messagesReducer} from "./messages";
import {fileManagerReducer} from "./fileManager";


export const reducers = combineReducers({
    inbox: inboxReducer,
    messages: messagesReducer,
    fileManager: fileManagerReducer
})